import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import { FeedbackError, Input, Button } from '../../../../components';

// eslint-disable-next-line react/prop-types
function FormCategory({ initialValues, categorySchema, onSubmit }) {
  return (
    <Formik initialValues={initialValues} validationSchema={categorySchema} onSubmit={onSubmit}>
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
        <Form onSubmit={handleSubmit} onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}>
          <Grid container justifyContent="space-around" paddingRight={5} marginTop={5}>
            <Grid item sm={11} marginRight={1}>
              <Input
                name="name"
                type="text"
                placeholder="Category name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                className={errors.name && touched.name && 'error'}
              />
              <FeedbackError name="name" errors={errors} touched={touched} />
            </Grid>
          </Grid>

          <Grid container justifyContent="center" paddingLeft={5} paddingRight={5} marginTop={3}>
            <Grid item sm={7}>
              <Button type="submit" label="Save" />
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

FormCategory.propTypes = {};

export default FormCategory;
